var $92d800447793d084$exports = {};
$92d800447793d084$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " non s\xE9lectionn\xE9.");
  },
  "longPressToSelect": "Appuyez de mani\xE8re prolong\xE9e pour passer en mode de s\xE9lection.",
  "select": "S\xE9lectionner",
  "selectedAll": "Tous les \xE9l\xE9ments s\xE9lectionn\xE9s.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Aucun \xE9l\xE9ment s\xE9lectionn\xE9",
      one: function one() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " s\xE9lectionn\xE9.");
  }
};
export { $92d800447793d084$exports as default };